import React from "react";
import RFQ_TABS_CONFIG from "./RFQ_TABS_CONFIG";

export default function RFQTabs({ activeTab, setActiveTab, counts, setCurrentPage, getActiveMainTab }) {

  const mainTab = getActiveMainTab(activeTab);
  const hasSubTabs = mainTab?.subTabs?.length > 0;

  return (
    <div>
      {/* Main Tabs */}
      <div className="d-flex gap-4 mb-3">
        {RFQ_TABS_CONFIG.map((tab) => {
          const isActive =
            activeTab === tab.key ||
            (tab.subTabs && tab.subTabs.some((sub) => `${tab.key}-${sub.key}` === activeTab));

          // Count for main tab: sum of subTabs or standalone count
          const tabstatus = tab.subTabs ? tab.subTabs.map(sub => sub.status).flat() : tab.status;
          const tabCount = tabstatus.reduce((sum, status) => {
            const match = counts.find(c => c._id === status);
            return sum + (match ? match.count : 0);
          }, 0);

          return (
            <div
              key={tab.key}
              className="pb-2 fw-semibold position-relative tab-item"
              style={{ cursor: "pointer", color: isActive ? "black" : "#6c757d" }}
              onClick={() => {
                if (tab.subTabs) {
                  const defaultChild = tab.defaultChild || tab.subTabs[0].key;
                  setActiveTab(`${tab.key}-${defaultChild}`);
                } else {
                  setActiveTab(tab.key);
                }
                setCurrentPage(1);
              }}
            >
              {tab.label} ({tabCount})
              {isActive && <div className="tab-underline" />}
            </div>
          );
        })}
      </div>

      {/* Sub-tabs */}
      {hasSubTabs && (
        <div className="d-flex gap-2 mb-3">
          {mainTab.subTabs.map((sub) => {
            const key = `${mainTab.key}-${sub.key}`;
            const isActive = activeTab === key;
            return (
              <button
                key={key}
                className={`fw-semibold`}
                style={{
                  borderRadius: "10px",
                  fontSize: "0.9rem",
                  padding: "16px 24px",
                  border: "1px solid #F9F9F9",
                  backgroundColor: isActive ? "#F9F9F9" : "white",
                }}
                onClick={() => {
                  setActiveTab(key);
                  setCurrentPage(1);
                }}
              >
                {sub.label}
                {/*  ({counts[key] || 0}) */}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
